//Bootstrap
try {
  require('bootstrap/js/dist/alert');
  require('bootstrap/js/dist/button');
  require('bootstrap/js/dist/carousel');
  require('bootstrap/js/dist/collapse');
  require('bootstrap/js/dist/dropdown');
  require('bootstrap/js/dist/modal');
  require('bootstrap/js/dist/scrollspy');
  require('bootstrap/js/dist/tab');
  require('bootstrap/js/dist/toast');
} catch (e) {};
import Tooltip from 'bootstrap/js/dist/tooltip';
import Popover from 'bootstrap/js/dist/popover';
// End bootstrap

import {DesignTool} from './components/DesignTool/DesignTool';

window.ManagerComponents = {
  DesignTool
};

var str_chars_in = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ';
var str_chars_out = 'aaaaaaaaaaaaooooooooooooeeeeeeeecciiiiiiiiuuuuuuuuynn';
var str_chars_ok = 'abcdefghijklmnopqrstuvwxyz0123456789-';

String.prototype.alias = function () {
    var str = this.toString();

    if (str.length == 0) {
        return '';
    }
    // en minuscule
    var str_in = str.toLowerCase();

    // chaine en sortie
    var str_out = '';


    // taille de la chaine
    var l = str_in.length;

    for (var i = 0; i < l; i++) {
        // chaque caractère
        var character = str_in.charAt(i);

        if (str_chars_ok.indexOf(character) >= 0) {
            // si éligible
            str_out += character;
        }
        else {
            // caractère transformable ?
            var pos = str_chars_in.indexOf(character);

            if (pos >= 0) {
                // si transformable
                str_out += str_chars_out[pos];
            }
            else {
                // pas de correspondance
                str_out += '-';
            }
        }
    }

    while (str_out.indexOf('--') >= 0) {
        str_out = str_out.replace(new RegExp("\-\-"), '-');
    }


    return str_out;
};

String.prototype.ucFirst = function () {
    var str = this.toString();

    if (str.length) {
        return str.substr(0, 1).toUpperCase() + str.substring(1);
    }
    else {
        return str;
    }
};

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (obj, start) {
        for (var i = (start || 0), j = this.length; i < j; i++) {
            if (this[i] === obj) {
                return i;
            }
        }
        return -1;
    }
}

window.doc = {

    // Params
    //---------

    brand: null, 		// json_encode de \Manager\Libs\Manager::getBrand
    layout: null, 		// ex : "default" ou "fancyframe" etc.
    loader: null, 		// $('#loader')
    loadpage: null,		 	// $('#loadpage')
    langTab: null, 		// la langue selectionné en cours (tabs de langue dans formulaires)
    me: null, 		// voir layout js
    tradLines: {}, 			// langues chargés dans les vues
    contentWidth: null, 		// largeur de #contenu en px, utile pour explorer
    is_dev: null, 		// v4
    is_dev_ip: null, 		// ip interne

    // concatène les attributs de l'objet o si ils sont non nuls
    getAttributes: function (o) {
        var s = '';
        for (var a in o) {
            if (o[a]) {
                s += a + '="' + o[a] + '" ';
            }
        }
        return s;
    },

    // TOOLS
    //------
    scrollTo: function (selector) {
        var y = $(selector).offset().top;
        $(document).scrollTop(y);
    },
    cssVars: function(){
        // Variable CSS permettant de récupérer la largeur de la page
        document.documentElement.style.setProperty('--vw', ($(window).width() * 0.01) + 'px');
        // Variable CSS permettant de récupérer la hauteur et la position du menu
        if ($('#menu').length) {
          document.documentElement.style.setProperty('--menu-top', ($('#menu').offset().top) + 'px');
          document.documentElement.style.setProperty('--menu-height', ($('#menu').outerHeight()) + 'px');
        }
    },

    // Initialisation des comportements pour l'interface qui reste fixe
    //-------------------------------------------------------------------

    initBodyDom: function () {
        // des racourcis
        doc.loader = $('#loader');
        doc.loadpage = $('#loadpage');

        // par defaut la langue selectionné est la langue du site
        if (site) // pas connecté, pas de site !
        {
            this.langTab = site.default_lang;
        }

        this.contentWidth = $('#contenu').length ? $('#contenu').width() : $('body').width();

        doc.cssVars();
        $(window).on('resize', function(){
            doc.cssVars();
        });

        doc.initContentDom();
    }
};


/*=========================================================================

=========================================================================*/


//function un peu générique d'ajaxpour le contenu des pages, pour des appels uniquement ajax :
//Fixe : type post, cache, timout, async, beforeSend = Gif loader, complete = cache le gif, error, message classiques. (sans le lien ressayer)
//Parametres : url, dataType (json ou html), les data en post, et un callback pour le succes
doc.ajax = function (url, dataType, data, callback) {
    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        cache: false,
        timeout: 10000,
        async: true,
        dataType: dataType,
        beforeSend: function (XMLHttpRequest) {
            doc.loader.show();
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            if (textStatus == 'timeout') {
                //doc.alerte(doc.langLine('err_page_seems_too_long'));
            }
            else {
                doc.alerte(doc.langLine('err_ajax_textstatus'));
            }
        },
        success: function (data, textStatus, XMLHttpRequest) {
            if (callback) {
                callback(data, textStatus, XMLHttpRequest);
            }
        },
        complete: function (XMLHttpRequest, textStatus) {
            doc.loader.hide();
        }
    });
};

doc.loadPage = function (hash) {
    // supprime les tooltip du body
    $('.tooltip').remove();

    // explorer.currentURL = site_url + hash; // TODO voir nico

    var url = site_url + hash + '?layout=loadpage';

    doc.ajax(url, 'html', null, function (data) {
        if (data == 'redirect') {
            document.location.href = site_url + 'sessions/start';
        }
        pagination.inited = false;
        doc.loadpage.html(data);
        doc.initContentDom();
    });
};

//valide un champs de formulaire en ajax
doc.validateField = function (item_id, url, form_id) {
    var item = $('#' + item_id);
    var field = form.getField(item_id);
    var timout = null;

    item.keyup(function () {
        doc.loader.show();

        field.reset();

        if (form_id) {
            var data = $('#' + form_id).serializeArray();
        }
        else {
            var data = item.serializeArray();
        }

        var field_name = item.attr('id');
        if (timout) {
            clearTimeout(timout);
        }

        timout = setTimeout(function () {
            doc.ajax(url + field_name, 'json', data, function (data) {
                if (data) {
                    field.error(data.error);
                }
                else {
                    field.reset();
                }
            });

        }, 700);


    });

    if (item.val()) {
        item.keyup();
    }
};

//NOTIFICATIONS
doc.notifications = {
	'add' : function(options){
		var $notifications	= $('.notifications').length === 0 ? $('<div class="toast-container notifications"></div>').appendTo('body') : $('.notifications');
		var $notification 	= $('<div></div>', {
			'class' 		: 'toast fade bg-' + (typeof options.state != 'undefined' ? options.state : 'info') + (typeof options.url != 'undefined' ? ' cursor-pointer' : '')
		});
    $notification.toast();

		$notification
		.data('pause', false)
		.append('<div class="toast-header">' + (typeof options.title != 'undefined' ? options.title : '') + '<button class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button></div><div class="toast-body">' + options.content  + (typeof options.url != 'undefined' ? '<p class="notification-link">En savoir plus</p>' : '')+ '</div>')
		.prependTo($notifications)
		.on({
			'click' : function(e){
				if(!$(e.target).hasClass('btn-close'))
				{
					return typeof options.url != 'undefined' ? location.href = options.url : false;
				}
			},
			'mouseenter' : function(e){
				$(this).data('pause', true);
			},
			'mouseleave' : function(e){
				$(this).data('pause', false);
			}
		});

		$notification.delay(200).queue(function(){
			doc.notifications.display($notification);
			$(this).dequeue();
		});
	},
	'remove' : function(notification){
		notification.removeClass('show').delay(500).queue(function(){
			clearInterval($(this).data('interval'));
			$(this).remove();
			$('.notifications:empty').remove();
			$(this).dequeue();
		});
	},
	'display' : function(notification){
		var $seconds = 0;
		notification.addClass('show').data('interval', setInterval(function(){
			$seconds += notification.data('pause') ? 0 : 1;
			if($seconds === 10)
			{
				doc.notifications.remove(notification);
			}
		}, 1000));
	}
};

/*=========================================================================
Initialisation des comportements pour les contenus (et ajax éventuellement)
=========================================================================*/

doc.initContentDom = function () {
    if (user.htmleditor != 'html') {
        // Initialisation de CKEditor
        if (typeof EMSCKEditor == 'object') {
            // Contenu CSS à charger par l'éditeur
            var contentcss = '';

            if (site !== null && typeof(user.displaymycssoneditor) != 'undefined' && user.displaymycssoneditor) {
                // Utilisation du proxy du manager si la marque est en HTTPS mais pas le site
                if ((site.protocol == 'http') && (doc.brand.protocol == 'https')) {
                    contentcss = site_url + 'site/design/siteThemeWYSIWYGCSS';
                }
                else {
                    if (site.theme_version)
                        contentcss = site.protocol + '://' + site.host + '/themes/tinymce.css?v=' + site.theme_version;
                    else
                        contentcss = site.protocol + '://' + site.host + '/themes/tinymce.css?v=' + Math.random() * 1000;
                }
            }
            else
                contentcss = file_url + 'manager/css/tinymce.css';

            // Version simplifié de l'éditeur ?
            var config_id = '';

            if (user.htmleditor == 'simple_mce') {
                config_id = 'simple';
            } else {
                config_id = 'default';
            }

            EMSCKEditor.init(user.lang, contentcss, config_id, (site === null ? 'fr' : site.default_lang));
        }
    }

    modal.init();

    // items reordonnables (vieux explorer et photos ecommerce / book, à remove)
    $('.js-sortable').sortable({
        tolerance: "intersect",
        forcePlaceholderSize: true,
        placeholder: {
            element: function (currentItem) {
                return $('<li class="sortable-placeholder" style="height:' + currentItem.outerHeight() + 'px"></li>')[0];
            },
            update: function (container, p) {
                return;
            }
        },
        stop: function (event, ui) {
            if (doc.onSortStop) {
                doc.onSortStop($(this), event, ui);
            }
        }
    });

    // champs de texte preremplis 							// TODO virer ca avec les nouveaux explorer..
    $('input.input-init').bind('click focus', function () {
        if ($(this).val() == $(this).attr('title')) {
            $(this).val('');
            $(this).removeClass('input-init');
        }
    });

    $('input.input-init').blur(function () {					// todo placeholder
        if ($(this).val() == '' && $(this).attr('title') != '') {
            $(this).val($(this).attr('title'));

            if (!$(this).hasClass('hasDatepicker')) {
                $(this).addClass('input-init');
            }
        }
    });

    // datepicker		// TODO refaire les datepicker  ?
    //init
    /*$('.js-show-calendar').each(function( index, element )
    {
        var id = $(this).attr('id');

        $(element).datepicker({
            dateFormat : 'yy-mm-dd',
            onSelect : function(date,inst)
            {
                var date = date.split('-');
                $('#'+id+'_y').val(date[0]);
                $('#'+id+'_m').val(date[1]);
                $('#'+id+'_d').val(date[2]);
                $('#'+id).change();
            },
            changeYear : true,
            yearRange: "-75:+25"
        });

        $('#'+id+'_d, #'+id+'_m, #'+id+'_y').change(function()
        {
            var date = $('#'+id+'_y').val() + '-' + $('#'+id+'_m').val() + '-' +$('#'+id+'_d').val();
            if(date.length != 10)
            {
                date = '';
            }
            $(element).datepicker('setDate', date);
        }).change();

        $('#btn_'+id).click(function(){
            if($(element).datepicker('widget').is(':hidden'))
            {
                $(element).datepicker('show');
                $(element).datepicker('widget').css({top: '+=' + $('#btn_'+id).outerHeight()});
            } else {
                $(element).datepicker('hide');
            }
        });
    });*/
    $('.js-show-calendar').each(function () {
        var id = $(this).attr('id');
        var wrapper = $(this).parents('.form-row').length ? $(this).parents('.form-row') : $(this).parents('.control-group');

        $(this).datepicker({
            format: 'yyyy-mm-dd',
            language: site.default_lang,
            daysOfWeekDisabled: typeof(datepickerDisabledDays) !== 'undefined' ? datepickerDisabledDays : new Array()
        })
            .on({
                'show': function () {
                  wrapper.removeClass('empty').addClass('focus');
                },
                'changeDate': function (ev) {
                    var day = ev.date.getDate();
                    var month = ev.date.getMonth() + 1;
                    var year = ev.date.getFullYear();
                    $('#' + id + '_d').val(day);
                    $('#' + id + '_m').val(month);
                    $('#' + id + '_y').val(year);
                    $(this).datepicker('hide');
                },
                'hide': function (ev) {
                    wrapper.removeClass('focus');
                }
            });

        $('#' + id + '_d, #' + id + '_m, #' + id + '_y').change(function () {
            //var date = $('#'+id+'_y').val() + '-' + $('#'+id+'_m').val() + '-' +$('#'+id+'_d').val();
            var date = new Date($('#' + id + '_y').val(), $('#' + id + '_m').val() - 1, $('#' + id + '_d').val());
            var convertedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if (date.length == 10) {
                $('#' + id).datepicker('setDate', convertedDate);
            }
        })

    });


    // check all - sélection des lignes d'un tableau
    $('th input.js-check-all').each(function () {
        var $master = $(this);
        var $slaves = $(this).closest('table').find('td :checkbox');

        $master.on('click', function () {
            $slaves.each(function () {
                $(this).prop('checked', $master.is(':checked'));
            });

        });

        $slaves.on('click', function () {
            $master.prop('checked', function () {
                return $slaves.filter(':not(:checked)').length == 0;
            });
        });
    });

    // onglet langues pour les formulaires multilingues
    $('[data-tabs="lang"]').on('shown.bs.tab', function (e) {
        // la langue selectionné
        doc.langTab = $(e.target).parent().data('tab-lang');
        // cache tous les champs de langues
        $('.version').addClass('d-none');

        // afficher les bonnes versions
        $('.version.version_' + doc.langTab).removeClass('d-none');
    });

    // init des tabs lang
    $('[data-tabs="lang"] .nav-link.active').trigger('shown.bs.tab');


    //lien fancybox version iframe
    $('[rel="fancyframe"]').on('click', function () {
        var url = $(this).attr('data-href');
        doc.openfancyframe(url);
        return false;
    });

    //avec hauteur de 100vh
    $('[rel="fancymodal"]').on('click', function () {
        var url = $(this).attr('data-href');
        doc.openFancyModal(url);
        return false;
    });

    // fermeture fancybox avec échap // à voir pour placer ca dans un callback de fancyframe
    $('body').on('keyup', function (e) {
        if (e.keyCode == 27)  // echap
        {
            $.fancybox.close();
            parent.$.fancybox.close();
        }
    });

    // Infobulles
    $('[rel="tooltip"]').each(function () {
        // Bs2 => Bs5
        if ($(this).is('[data-placement]')) {
          $(this).attr('data-bs-placement', $(this).attr('data-placement'));
          $(this).removeAttr('data-placement');
        }

        doc.tooltipInit($(this));
    });

    // Popovers
    $('[data-toggle="popover"]').each(function () {
        // Bs2 => Bs5
        if ($(this).is('[data-placement]')) {
          $(this).attr('data-bs-placement', $(this).attr('data-placement'));
          $(this).removeAttr('data-placement');
        }
        if ($(this).is('[data-content]')) {
          $(this).attr('data-bs-content', $(this).attr('data-content'));
          $(this).removeAttr('data-content');
        }

        // Replace [data-state] by [data-class]
        if ($(this).is('[data-state]')) {
          $(this).attr('data-class', $(this).attr('data-state'));
          $(this).removeAttr('data-state');
        }

        doc.popoverInit($(this));
    });


    /**
     * Activation de l'arbo js sur les select ayant la classe  js-arbo
     */

    $('select.js-arbo').each(function () {
        doc.initMultiselect($(this));
    });

    $('.js-shownextdiv').on('change', function () {
      var wrapper = $(this).parents('.form-row').length ? $(this).parents('.form-row') : $(this).parents('.control-group');
      if ($(this).prop('checked')) {
          wrapper.next().slideDown(300);
      }
      else {
          wrapper.next().slideUp(300);
      }
    }).change();

    $('.js-hidenextdiv').on('change', function () {
      var wrapper = $(this).parents('.form-row').length ? $(this).parents('.form-row') : $(this).parents('.control-group');
      if ($(this).prop('checked')) {
          wrapper.next().slideUp(300);
      }
      else {
        wrapper.next().slideDown(300);
      }
    }).change();


    //gestion pays -> indicatif téléphones dans les formulaires ayant à la fois un .js-country et au moins un .js-phone
    $('.js-country').change(function () {
        var data = new Object;
        data.country = $(this).val();
        var url = site_url + 'site/welcome/phoneprefix';

        doc.ajax(url, 'json', data, function (data) {
            if (data) {
                var indicatif = '+' + data.indicatif;
                $('.js-phone option').removeAttr('selected');
                $('.js-phone option[value="' + indicatif + '"]').attr('selected', 'selected');
            }
        });
    });

    if ($('.js-phone').length) {
        if (!$('.js-phone').val()) {
            $('.js-country').change();
        }
    }

    // popup confirmez l'action sur les liens douteux (supression) benjamin je change le selecteur pour gérer les a créer en js/ajax
    $(document).on('click', 'a[data-confirm]', function (e) {
        var str = $(this).data('confirm');
        var url = $(this).data('url');

        modal.forge(doc.langLine('alert_title'), str,
            '<a href="#" class="btn btn-light" data-bs-dismiss="modal">' + doc.langLine('cancel') + '</a> ' +
            '<button type="button" class="btn btn-secondary confirm-deletion" data-url="' + url + '">' + doc.langLine('confirm') + '</button>'
        );
        modal.show();

        e.preventDefault();
    });

    $(document).on('click', '.confirm-deletion', function () {
        window.location.href = $(this).data('url');
    });

    // alerte
    $('a[data-alert]').on('click', function () {
        var str = $(this).data('alert');
        doc.alerte(str);
        return false;
    });

    if (typeof applyCheckboxesDeleteEvents !== 'undefined') {
        applyCheckboxesDeleteEvents();
    }

    // formulaires
    window.forms.init();
};

/*===============================================================================
TOOLTIPS
===============================================================================*/
doc.tooltipInit = function ($elem) {
  // Instancied ?
  var instance = Tooltip.getInstance($elem[0]);

  if (instance === null) {
    var className = $elem.is('[data-state]') ? $elem.attr('data-state') : ($elem.hasClass('help-icon') ? 'info' : null);
    className = (className === null) && $elem.is('[data-offer]') ? 'offer-' + $elem.attr('data-offer') : className;

    new Tooltip($elem[0],{
      animation: false, // @fixme flickering problem when enabled (conflict from other CSS animation rule ?)
      container: 'body',
      html: true,
      template: `<div class="tooltip${className !== null ? ' ' + className : ''}"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>`
    });
  }
}

/*===============================================================================
POPOVERS
===============================================================================*/
doc.popoverInit = function ($elem) {
  // Instancied ?
  var instance = Popover.getInstance($elem[0]);

  if (instance === null) {
    var className = $elem.is('[data-class]') ? $elem.attr('data-class') : null;

    new Popover($elem[0],{
      container: 'body',
      html: true,
      template: `<div class="popover${className !== null ? ' ' + className : ''}">` +
                  `<div class="popover-arrow"></div>` +
                  `${$elem.is('[title]') ? '<h3 class="popover-header"></h3>' : ''}` +
                  `<div class="popover-body"><div>` +
                `</div>`
    });

    $elem.click(function (e) {
      e.preventDefault()
    });
  }
}


/*===============================================================================
Modification champs URL
===============================================================================*/
// onTitleChange : modifier l'URL si on change de titre (juste à la creation)
doc.initURLFields = function (url, onTitleChange, isItem) {
    // verouillage/deverrouillage
    $('a.lock').click(function () {
        $(this).prev('input:disabled').prop('disabled', false).focus();
    });

    //défocus du champs uri
    $('.js-uri').blur(function () {
        console.log('blur');
        $(this).val($(this).val().alias()); //urifi le champ
        $(this).prop('disabled', true);
    });


    // modification d'un champ select.tree
    $('select.tree').change(function () {
        var cat_id = $(this).val();

        // on va chercher l'url de cette catégorie dans chaque langue supportée
        $.post(url + cat_id, null, function (data) {
            if (data) {
                if (data.e) {
                    alert(data.e);
                }
                else {
                    for (lang in data) {
                        $('#urlspan_' + lang).text(data[lang]);
                    }
                }
            }
        }, 'json');

        var val = $(this).val().alias();
        $('span.url').html(val + '/');
    });

    if (onTitleChange) {
        // modification d'un champ titre
        $('input.title').keyup(function () {
            // valeur du titre
            var val = $(this).val().alias();

            // id (pour connaitre la langue)
            var id = $(this).attr('id').replace('title_', '').replace('name_', '');

            // modifier valeur du champ fake et du vrai
            $('#seo_uri_fake_' + id).val(val);

            if ($('input.seoTitle').val() == '') {
              $('[data-role="meta-title"]').html($(this).val());
            }

            // modifier texte de l'URL
            $('.js-uri').keyup();

        });
    }

    //au change de l'input par l'user, change l'url en dessous
    $('.js-uri').keyup(function () {
        //valeur urlifié
        var val = $(this).val().alias();

        //.html
        if (isItem) {
            //$('#urisuffix_'+lang).text('.html');
            //val += '.html';
        }
        //la langue
        var lang = $(this).attr('id').replace('seo_uri_fake_', '');

        //et le vrai input hidden
        $('#seo_uri_' + lang).val(val);

        if (isItem) {
            //$('#urisuffix_'+lang).text('.html');
            val += '.html';
        }

        //l'url span
        $('#urispan_' + lang).html(val);
    });

    //init au chargement de la page
    $('.js-uri').keyup();
};


//confirmation pour event douteux (ex suppression de qqch)
//fancybox une confirmation oui / non, suit le lien si oui
doc.confirm = function (msg, url) {
    var callback = function () {
        window.location.href = url;
    }

    window.popup.confirm(msg, callback);
};

//confirmation, qui appelle toujours url mais en ajax (voir plus haut pour commentaire sur doc.postAjaxForm)
doc.ajaxConfirm = function (msg, url) {
    var callback = function () {
        doc.postAjaxForm(url);
    }

    window.popup.confirm(msg, callback);
};

doc.postAjaxForm = function (url, data) {
    if (!data) {
        data = {};
    }

    url = url + '?layout=loadpage';

    doc.ajax(url, 'html', data, function (data, textStatus, XMLHttpRequest) {
        doc.loadpage.html(data);
        doc.initContentDom();
    });
};

// ouverture de la fancyframe en js
doc.openfancyframe = function (url) {
    // rajoute le layout en GET
    //---------------------------

    url += url.indexOf('?') != -1 ? '&layout=fancyframe' : '?layout=fancyframe';

    // taille
    //---------------------------
    var width = $('body').hasClass('fb-content') ? $('body').width() - 50 : doc.contentWidth;
    var height = Math.round($(window).height() * 0.8);

    // ouvre fancybox
    //----------------

    $.fancybox({
        margin: 0,
        padding: 0,
        width: width,
        height: height,
        autoSize: false,
        autoResize: true,
        autoCenter: true,
        fitToView: false,
        scrolling: 'auto',
        fixed: true,
        wrapCSS: 'fancyframe', // classe css
        modal: true, 		// desactiver bouton close & fermeture intempestive
        closeBtn: false,
        type: 'iframe',
        href: url,
        afterClose: function () {
            if (doc.afterFancyClose) {
                doc.afterFancyClose();
            }
        }
    });
};

doc.openFancyModal = function (url) {
    // rajoute le layout en GET
    //---------------------------

    url += url.indexOf('?') != -1 ? '&layout=fancymodal' : '?layout=fancymodal';

    // largeur
    //---------------------------
    var width = $('body').hasClass('fb-content') ? $('body').width() - 50 : doc.contentWidth;

    // ouvre fancybox
    //----------------

    $.fancybox(
        {
            margin: 0,
            padding: 0,
            width: width,
            height: '100%',
            fixed: true,
            wrapCSS: 'fancymodal', // classe css
            modal: true, 		// desactiver bouton close & fermeture intempestive
            type: 'iframe',
            href: url,
            autoSize: false,
            url: url,
            closeBtn: false, 		// de toute facon avec "modal" a true il ne s'affichere pas
            scrolling: 'auto',
            keys:
                {
                    close: [27] // TODO john
                },
            afterClose: function () {
                if (doc.afterFancyClose) {
                    doc.afterFancyClose();
                }
            }
        });
}

function strpos(haystack, needle, offset) {
    var i = (haystack + '').indexOf(needle, (offset || 0));
    return i === -1 ? false : i;
};


/*=========================================================================
Choix de la langue du manager
=========================================================================*/

doc.setLanguage = function (lang) {
    document.location.href = site_url + 'sessions/lang/' + lang;
};


/*===============================================================================
Bandeau de confirmation ou d'erreur // TODO à virer et utiliser autrement
===============================================================================*/

doc.openAlertMsg = function (message, type, tempo) {
    if ($('#contenu .alert.' + type).length) {
        $('#contenu .alert.' + type).html(message);
    }
    else {
        $('#contenu').prepend('<div class="alert ' + type + '">' + message + '</div>');
    }

};

// GROSSSSSSSE BOUUUUUUZZZZE
/*=========================================================================
Transforme un select en select avec arbo (plugin multiselect)
argument: node qui est le noeud (le select donc) que l'on veut transformer
=========================================================================*/

doc.initMultiselect = function (node) {
    // On check si le premier option est vide afin de le virer, il contient le "Sélectionnez" qu'on remplace par le nom du module
    var first_option = node.find('option:first');

    if (first_option.val() == '' && first_option.attr('rel') != '0') {
        node.find('option:first').remove();
    }

    node.multiSelect({
        selectAllText: doc.langLine('multiselect_selectall'),
        noneSelected: doc.langLine('multiselect_select'),
        oneSelected: '% ' + doc.langLine('multiselect_one_category_selected'),
        oneOrMoreSelected: '% ' + doc.langLine('multiselect_more_categorie_selected'),
        selectAll: false
    }, function callback(r) {
        // On appelle selectCallback si elle existe
        if ('function' == typeof(selectCallback)) { 	// jamais vu ca sérieux, du code en verlan..
            selectCallback(r);
        }
        return false;
    });

    $('.multiSelect').parent().css({'position': 'relative'});
};


/*=========================================================================
Ligne de trad js
=========================================================================*/
doc.langLine = function (key) {
    //todo check dev_ip return doc.tradLines[key] ? doc.tradLines[key] : '[T-Js '+key+']';
    return doc.tradLines[key] ? doc.tradLines[key] : '';
};

/*=========================================================================
Alerte : MAJ 17 dec 2012 : bootstrap (modal)
=========================================================================*/
doc.alerte = function (msg, btn_class, title) {
    title = (typeof title === 'undefined') ? doc.langLine("alert_title") : title;
    btn_class = (typeof btn_class === 'undefined') ? '' : ' btn-' + btn_class;

    modal.forge(title, msg, '<a href="#" class="btn btn-light' + btn_class + '" data-bs-dismiss="modal">' + doc.langLine('ok_btn') + '</a>').show();
};


/**
 * sélectionner une image à partir de l'espace de stockage d'images
 */

doc.selectImage = function () {
    var ac = new Date().getTime();
    var url = site_url + 'site/stoimages/select?ac=' + ac;
    doc.openfancyframe(url);
}


/**
 * lorsque l'image est selectionnée
 */

doc.onImageSelected = function (image) {
    if (typeof onImageSelected == 'function') {
        onImageSelected(image);
    }
    else {
        alert('fonction "onImageSelected" non définie');
    }
    $.fancyframe.close();
}


doc.selectFile = function () {
    var ac = new Date().getTime();
    var url = site_url + 'site/stofiles/select?ac=' + ac;
    doc.openfancyframe(url);
}

/*************************************************************************************************
 *                            FORMULAIRES
 *            Fct générique sur dom ou autre concernant les formulaires du manager
 ************************************************************************************************/

// objet form
//------------

window.form = {
  prototype: {

      // cache / affiche le div field complet en partant de l'input (ex : #title)
      hideField: function (selector) {
        var wrapper = $(selector).closest('.form-row:first').length ? $(selector).closest('.form-row:first') : $(selector).closest('.control-group:first');
        return wrapper.addClass('d-none');
      },

      showField: function (selector) {
        var wrapper = $(selector).closest('.form-row:first').length ? $(selector).closest('.form-row:first') : $(selector).closest('.control-group:first');
        return wrapper.removeClass('d-none');
      }

  },
  getField: function (item_id) {
    return field.getInstance(item_id);
  }
};


// objet field
//-------------

var field = function (item_id) {
    // params
    //--------

    this.item = $('#' + item_id);
    this.isControlGroup = this.item.closest('.control-group').length;
    this.dom = this.isControlGroup ? this.item.closest('.control-group') : this.item.closest('.form-row');

}

field.prototype = {

    show: function () {
        this.dom.removeClass('d-none');

        return this;
    },

    hide: function () {
        this.dom.addClass('d-none');

        return this;
    },

    error: function (error) {
        // reset le statut erreur, succes ou autre
        this.reset();

        // set l'erreur
        //--------------

        // si ya un field-info, faudra le remettre en apres l'erreur
        var info = this.dom.find('.form-text').detach();

        // ajoute l'erreur au dom
        if (this.isControlGroup) {
          this.dom.addClass('error').find('.controls').append('<div class="invalid-feedback">' + error + '</div>');
        // ajoute l'erreur sur l'item
        } else {
          this.item.addClass('is-invalid').after('<div class="invalid-feedback">' + error + '</div>');
        }

        // remet l'info (div info bleu avec fleche)
        if (info) {
          if (this.isControlGroup) {
            this.dom.find('.controls').append(info);
          } else {
            info.after(this.item);
          }
        }

        return this;
    },

    reset: function () {
        // reset le statut erreur, succes ou autre
        if (this.isControlGroup) {
          this.dom.removeClass('error');
        } else {
          this.item.removeClass('is-invalid');
        }
        this.dom.find('.invalid-feedback').remove();

        return this;
    },

    // remplie un select : champs requis : value - label
    options: function (options) {
        var dom = '';

        for (var i = 0; i < options.length; i++) {
            dom += '<option value="' + options[i].value + '">' + options[i].label + '</option>';
        }

        this.item.find('option').remove();
        this.item.append(dom);

        return this;
    },

    // selectionne une option d'un select
    select: function (option) {
        this.item.find('option:selected').prop('selected', false).removeAttr('selected');

        if (option) {
            this.item.find('option').each(function (i, elem) {
                if ($(elem).val() == option) {
                    $(elem).prop('selected', true);
                }
            });
        }

        return this;
    }

};

// singleton
field.instances = [];

field.getInstance = function (item_id) {
    if (!this.instances[item_id]) {
        this.instances[item_id] = new field(item_id);
    }

    return this.instances[item_id];
};


/*=========================================================================
Pagination et tris
=========================================================================*/

//event sur pagination
window.pagination = new Object();
var pagination = window.pagination;

pagination.url = '';
pagination.inited = false;
pagination.sort_field = null;
pagination.sort_way = null;


pagination.init = function (url) {
    if (!pagination.inited) {
        pagination.inited = true;
        pagination.url = url;

        // comportement de la pagination
        $('.pagination_limit').change(function () {
            var pagination_limit = $(this).val();
            $('.pagination_page').each(function (index, element) {
                $(element).val('1');
            });

            $('.pagination_limit').each(function (index, element) {
                $(element).val(pagination_limit);
            });
            pagination.doPaginate();
        });

        $('.pagination_page').change(function () {
            pagination.gotoPage($(this).val(), pagination.dataPost);
        });

        // Si on clic sur l'entete d'un tableau ayant la class "js-datasort" on appelle doSort en passant le noeud cliqué
        $('th a.js-datasort').click(function (e) {
            $(this).addClass('active');
            pagination.doSort($(this));
            return false;
        });
    }
};

pagination.doPaginate = function (dataPost, successFullCallback) {
    pagination.inited = false;

    if (!dataPost) {
        var dataPost = pagination.dataPost;
    }

    if (!dataPost) {
        dataPost = [];
    }

    if ($('.pagination_limit:first').val()) {
        if (typeof(dataPost.push) == 'function') {
            dataPost.push({name: 'pagination_limit', value: $('.pagination_limit:first').val()});
            dataPost.push({name: 'pagination_page', value: $('.pagination_page:first').val()});
        }
        else {
            dataPost.pagination_limit = $('.pagination_limit:first').val();
            dataPost.pagination_page = $('.pagination_page:first').val();
        }
    }

    if (this.sort_field && this.sort_way) {
        dataPost.sort_field = this.sort_field;
        dataPost.sort_way = this.sort_way;
    }

    doc.ajax(pagination.url, 'html', dataPost, function (data, textStatus, XMLHttpRequest) {
        $('#pagination_content').html(data);
        doc.initContentDom();
        if (successFullCallback !== undefined) {
            successFullCallback();
        }
    });
};


//navigation : boutons précédent, suivant, début, fin
pagination.gotoPage = function (x) {
    $('.pagination_page').each(function (index, element) {
        $(element).val(x);
    });
    pagination.doPaginate();
};


// Pour faire un tri sur un tableau, on passe le noeud en parametre
pagination.doSort = function (node) {
    // Si la classe "asc" est présente, c'est que le tri était ascendant
    if (node.hasClass('asc')) {
        this.sort_way = 'desc';
    }
    else {
        this.sort_way = 'asc';
    }

    // On récupère l'url vers laquelle poster la requete
    //var url					= $('#pagination_url').val();
    //demander à xav kesaco
    if (!dataPost) {
        var dataPost = pagination.dataPost;
    }
    else {
        var dataPost = {};
    }

    // On récupère le champ bdd sur lequel faire le tri ainsi que le sens du tri
    this.sort_field = node.attr('rel');

    pagination.doPaginate(dataPost);
};


// popup avec fancybox
window.popup = {}; 		// TODO REDO bootstrap

// fonction à rappeler lors de la confirmation
window.popup.onYes = null;
window.popup.onNo = null;

//demande de confirmation, question à afficher, fonction js à appeler
window.popup.confirm = function (question, onYes, onNo, forceConfirmEnabled, textyes, textno) {
    //si textyes et textno ne sont pas défini, OK et Annuler seront les textes par défaut
    textyes = (typeof textyes === "undefined") ? doc.langLine('ok_btn') : textyes;
    textno = (typeof textno === "undefined") ? doc.langLine('cancel_btn') : textno;

    //si onNo pas définis
    if (!onNo) {
        onNo = function () {
        };
    }

    // la confirmation est elle optionnelle
    if (forceConfirmEnabled) {
        // on a déjà choisi de ne plus afficher les confirmations
        if (user.forceConfirm) {
            // on lance directement le callback du bouton de validation
            onYes();
        }
        else {
            // on demande quoi faire
            window.popup.onYes = onYes;
            window.popup.onNo = onNo;

            var popupTemplate =
                '<div class="modal fade modal-alert">' +
                ' <div class="modal-dialog modal-dialog-centered">' +
                '  <div class="modal-content">' +
                '	  <div class="modal-body text-center">' +
                '		 <p>' + question + '</p>' +
                '		 <div class="form-check">' +
                '	    <input class="form-check-input" type="checkbox" name="forceconfirm" id="forceconfirm" value="1" /> ' +
                '     <label for="forceconfirm" class="form-check-label">' + doc.langLine('do_not_show_this_message') + '</label>' +
                '	   </div>' +
                '   </div>' +
                '   <div class="modal-footer">' +
                '		<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" onclick="popup.onNo();">' + textno + '</button>' +
                '		<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal" onclick="popup.saveForceConfirm();popup.onYes();">' + textyes + '</button>' +
                '   </div>' +
                ' </div>' +
                ' </div>' +
                '</div>';

            $(popupTemplate).modal('show');
        }
    }
    else {
        window.popup.onYes = onYes;
        window.popup.onNo = onNo;

        var popupTemplate =
            '<div class="modal fade modal-alert">' +
            ' <div class="modal-dialog modal-dialog-centered">' +
            '  <div class="modal-content">' +
            '	  <div class="modal-body text-center">' +
            '		 <p>' + question + '</p>' +
            '	  </div>' +
            '   <div class="modal-footer">' +
            '		<button type="button" class="btn btn-light btn-sm" data-bs-dismiss="modal" onclick="popup.onNo();">' + textno + '</button>' +
            '		<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal" onclick="popup.onYes();">' + textyes + '</button>' +
            '   </div>' +
            '  </div>' +
            ' </div>' +
            '</div>';

        $(popupTemplate).modal('show');
    }
};

// sauver le fait de forcer la confirmation
window.popup.saveForceConfirm = function () {
    if ($('#forceconfirm').is(':checked')) {
        $.get(site_url + 'user/account/forceconfirm/1');
        user.forceConfirm = true;
    }
};


window.popup.show = function (content) {
    $.fancybox(content,
        {
            'autoDimensions': false,
            'width': 400,
            'height': 150,
            'padding': 0,
            'showCloseButton': false
        });
};
window.popup.close = function () {

    $.fancybox.close();
};

/*************************************************************************************************
 *                            DETECTION VIEUX NAVIGATEUR
 ************************************************************************************************/

var detectBrowser =
    {
        browser: '', 		// navigateur detecté
        browserVersion: 0, 		// version navigateur detecté
        os: '', 		// os detecté

        // Tableau : 		Opera / MSIE / Netscape / Chrome / Safari / Firefox
        // 			os : 	Any / Windows / Mac / Linux / iPhone
        notSupportedBrowsers: [
            {'os': 'Any', 'browser': 'MSIE', 'version': 7},
            {'os': 'Any', 'browser': 'Firefox', 'version': 4},
            {'os': 'Any', 'browser': 'Chrome', 'version': 15.9}
        ],

        // reference des os
        operatingSystems: [
            {'searchString': navigator.platform, 'name': 'Windows', 'subStr': 'Win'},
            {'searchString': navigator.platform, 'name': 'Mac', 'subStr': 'Mac'},
            {'searchString': navigator.platform, 'name': 'Linux', 'subStr': 'Linux'},
            {'searchString': navigator.userAgent, 'name': 'iPhone', 'subStr': 'iPhone/iPod'}
        ],

        init: function () {
            //déjà affiché pour cette session, on affiche pas
            if (this.readCookie('bdnotice') == 1) {
                return;
            }

            // detect
            this.detectBrowser();
            this.detectOS();

            //navigateurs exotiques on fait rien
            if (this.browser == '' || this.browser == 'Unknown' || this.os == '' || this.os == 'Unknown' || this.browserVersion == '' || this.browserVersion == 0) {
                return;
            }

            // vieux ?
            var oldBrowser = false;
            var notSupportedBrowsers = this.notSupportedBrowsers;

            for (var i = 0; i < notSupportedBrowsers.length; i++) {
                if (notSupportedBrowsers[i].os == 'Any' || notSupportedBrowsers[i].os == this.os) {
                    if (notSupportedBrowsers[i].browser == 'Any' || notSupportedBrowsers[i].browser == this.browser) {
                        if (notSupportedBrowsers[i].version == "Any" || this.browserVersion <= parseFloat(notSupportedBrowsers[i].version)) {
                            oldBrowser = true;
                            break;
                        }
                    }
                }
            }

            if (oldBrowser) {
                this.displayNotice();
            }
        },

        // detect browser et version
        detectBrowser: function () {
            if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                this.browser = 'Opera';
            } else if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
                this.browser = 'MSIE';
            } else if (/Navigator[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                this.browser = 'Netscape';
            } else if (/Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                this.browser = 'Chrome';
            } else if (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                this.browser = 'Safari';
                /Version[\/\s](\d+\.\d+)/.test(navigator.userAgent);
                this.browserVersion = new Number(RegExp.$1);
            } else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                this.browser = 'Firefox';
            }

            if (this.browser == '') {
                this.browser = 'Unknown';
            } else if (this.browserVersion == 0) {
                this.browserVersion = parseFloat(new Number(RegExp.$1));
            }
        },

        //detection de l'os
        detectOS: function () {
            for (var i = 0; i < this.operatingSystems.length; i++) {
                if (this.operatingSystems[i].searchString.indexOf(this.operatingSystems[i].subStr) != -1) {
                    this.os = this.operatingSystems[i].name;
                    return;
                }
            }

            this.os = "Unknown";
        },

        //affiche la fancyframe (si cookie etc..)
        displayNotice: function () {
            //affiche
            doc.openfancyframe(site_url + 'user/welcome/old_browser_notice');

            //pose cookie
            this.writeCookie('bdnotice', 1, 1);
        },

        writeCookie: function (name, value, days) {
            var expiration = "";
            if (parseInt(days) > 0) {
                var date = new Date();
                date.setTime(date.getTime() + parseInt(days) * 24 * 60 * 60 * 1000);
                expiration = '; expires=' + date.toGMTString();
            }

            document.cookie = name + '=' + value + expiration + '; path=/';
        },

        readCookie: function (name) {
            if (!document.cookie) {
                return '';
            }

            var searchName = name + '=';
            var data = document.cookie.split(';');

            for (var i = 0; i < data.length; i++) {
                while (data[i].charAt(0) == ' ') {
                    data[i] = data[i].substring(1, data[i].length);
                }

                if (data[i].indexOf(searchName) == 0) {
                    return data[i].substring(searchName.length, data[i].length);
                }
            }

            return '';
        }


    };

/*************************************************************************************************
 *                            POPOVER
 ************************************************************************************************/

/*
 * Affiche une tooltip sur (sous en fait) un element (genre input)
 *
 * Usage
 * ------
 *
 * //récupere une instance pour mon item (creation automatique)
 * var tooltip = popover.getInstance('item_id');
 *
 * // titre (facultatif)
 * tooltip.title('Mon titre');
 *
 * // contenu
 * tooltip.content('bonjour');
 *
 * // affiche / cache | duration pour faire jolie
 * tooltip.hide(); tooltip.show();  	| tooltip.show(400);
 *
 * // appliquer une classe
 * tooltip.cssClass('success');
 *
 * // tout est chainable
 * popover.getInstance(item_id).title('titre').content('bonjour').class('error').show(400);
 *
 * // ISSUE
 * Si vous avez l'impression que la popover est mal placé en hauteur, notemment sur chrome,
 * appellez là au $(window).load() au lieu du document.ready
 */

var popover = function (item_id) 	// ne pas faire de new, passer par getInstance de préférence
{
    // params
    //---------
    this.item = $('#' + item_id);
    this.dom = null;


    //-----------------

    // creation du dom
    var dom =
        '<div class="popover bottom" style="position:absolute;display:none;">' +
        '<div class="arrow"></div>' +
        '<div class="popover-inner">' +
        '<button data-dismiss="popover" class="close" type="button" style="float:right;background:none;border:none;font-size:20px;font-weight:bold;padding:3px 5px;opacity:0.2;cursor:pointer;">×</button>' +	// close button
        '<h3 class="popover-title"></h3>' + 	// titre here
        '<div class="popover-content">' +
        // content here
        '</div>' +
        '</div>' +
        '</div>';

    this.dom = $(dom);

    // pose le dom
    $('body').append(this.dom);

    // event bouton close
    this.dom.on('click', '[data-dismiss="popover"]', $.proxy(this, 'hide'));
}

popover.prototype =
    {
        show: function (duration) {
            // calcul position

            var element_position = this.item.offset();
            var element_position_x = element_position.left - 5;
            var element_position_y = element_position.top + this.item.height() + 3;

            this.dom.css('top', element_position_y + 'px').css('left', element_position_x + 'px');

            if (duration) {
                this.dom.show(duration, 'linear');
            }
            else {
                this.dom.show();
            }

            return this;
        },

        hide: function (duration) {
            if (duration) {
                this.dom.hide(duration, 'linear');
            }
            else {
                this.dom.hide();
            }

            return this;
        },

        title: function (title) {
            this.dom.find('.popover-title').html(title);

            return this;
        },

        content: function (content) {
            this.dom.find('.popover-content').html(content);

            return this;
        },

        cssClass: function (css_class) {
            this.dom.attr('class', 'popover bottom ' + css_class)

            return this;
        }
    };

// instances de popovers
//------------------------

popover.instances = []; // sorte de variables static

// "singleton"
popover.getInstance = function (item_id) {
    if (!popover.instances[item_id]) {
        popover.instances[item_id] = new popover(item_id);
    }

    return popover.instances[item_id];
};


/*************************************************************************************************
 *                            PLUGIN SELECT TREE
 ************************************************************************************************/

// http://www.lafermeduweb.net/billet/jquery-plugin-boilerplate-une-structure-de-base-pour-dev-vos-plugins-1100.html

(function ($) {

    $.categoryTree = function (element, options) {
        // options par défaut
        var defaults = {};

        // on utilise "plugin" au lieu de "this"
        var plugin = this;

        // est ce que c'est ouvert ?
        plugin.isopen = false;

        // valeurs possibles
        plugin.values = new Array();

        // valeurs sélectionnées
        plugin.selectedValues = new Array();

        // autoriser selection multiple
        plugin.allowMultiple = false;

        // propriétés du plugin, accessibles via
        // plugin.settings.property de l'intérieur
        // element.data('categoryTree').settings.property de l'extérieur
        plugin.settings = {};

        // version JQuery du fragment de dom en cours
        var $element = $(element);


        // init du plugin
        plugin.init = function () {
            // paramètres par défaut + options
            plugin.settings = $.extend({}, defaults, options);

            if ($element.attr('multiple')) {
                plugin.allowMultiple = true;
            }
            else {
                plugin.allowMultiple = false;
            }

            // code HTML à générer
            var html = '';

            html += '<div class="ui-categoryTree fieldtype-category-tree">';
            html += '<div class="ui-categoryTree-header">';
            html += '<div class="ui-categoryTree-label">Sélectionnez';
            html += '</div>';
            html += '<div class="ui-categoryTree-dropdown">';
            html += '</div>';
            html += '</div>';
            html += '<div class="ui-categoryTree-content">';
            html += '<div class="ui-categoryTree-items">';
            html += '</div>';
            html += '</div>';
            html += '</div>';

            // racourcis vers les fragments de dom
            plugin.dom = $(html);

            plugin.container = plugin.dom.find('.ui-categoryTree');
            plugin.header = plugin.dom.find('.ui-categoryTree-header');
            plugin.label = plugin.dom.find('.ui-categoryTree-label');
            plugin.dropdown = plugin.dom.find('.ui-categoryTree-dropdown');
            plugin.content = plugin.dom.find('.ui-categoryTree-content');
            plugin.items = plugin.dom.find('.ui-categoryTree-items');

            // liste des options du SELECT
            var opts = $element.find('option');

            // boucle dessus
            for (var i = 0; i < opts.length; i++) {
                // option en cours
                var opt = opts.eq(i);

                // stocke la valeur comme valeur possible
                plugin.values.push(opt.attr('value'));


                var level = opt.attr('data-depth') == undefined ? 0 : opt.attr('data-depth');

                // crée le code HTML de l'item
                var html = '<a href="javascript:void(0);" style="text-indent:' + (level * 10) + 'px" class="ui-categoryTree-item ui-categoryTree-depth-' + level + '" data-value="' + opt.attr('value') + '" title="' + opt.text() + '"><i class="fa fa-folder-o"></i> ' + opt.text() + '</a>';

                // crée le dom de l'item
                var item = $(html);

                // clic item
                item.bind('click', plugin.itemClick);

                // ajoute le dom dans le div items
                plugin.items.append(item);

                if (opt.attr('selected') == "selected") {
                    plugin.selectedValues.push(opt.attr('value'));
                }
            }

            // largeur du select
            var width = $element.width();

            // largeur du header = largeur du select
            plugin.header.width(width);

            // largeur du content : largeur du select
            plugin.content.width(width).hide();

            // clic sur le dropdown
            plugin.header.bind('click', plugin.toggle);

            // ajoute le dom au document
            $element.after(plugin.dom);

            // cacher le select
            $element.hide();

            // mise à jour de l'affichage
            plugin.updateSelectedValues();
        };


        // clic item
        plugin.itemClick = function (e) {
            // empécher la fermeture du menu
            e.stopPropagation();

            // valeur de l'item
            var value = $(e.target).attr('data-value');

            if (plugin.hasValue(value)) {
                plugin.removeValue(value)
            }
            else {
                plugin.addValue(value)
            }

            // déclenche l'événement change
            $element.trigger('change');

            // sélection multiple possibl
            if (!plugin.allowMultiple) {
                plugin.close();
            }
        }


        // ouvre/ferme le menu
        plugin.toggle = function (e) {
            // empécher la fermeture du menu
            e.stopPropagation();

            if (plugin.isopen) {
                plugin.close();
            }
            else {
                plugin.open();
            }
        };


        // ouvre le menu
        plugin.open = function () {
            plugin.isopen = true;
            plugin.content.show().parents('.fieldtype-category-tree').addClass('focus');

            $(document).bind('click.categorytree', plugin.close);
        };


        // ferme le menu
        plugin.close = function () {
            plugin.isopen = false;
            plugin.content.hide().parents('.fieldtype-category-tree').removeClass('focus');

            $(document).unbind('click.categorytree', plugin.close);
        };


        // ajouter la valeur value à la selection
        plugin.addValue = function (value) {
            // pas disponible
            if ($.inArray(value, plugin.values) == -1) {
                return;
            }

            if (plugin.allowMultiple) {
                // pas encore selectionnée
                if ($.inArray(value, plugin.selectedValues) == -1) {
                    // on la selectionne
                    plugin.selectedValues.push(value);
                }
            }
            else {
                // une seule valeur
                plugin.selectedValues = [value];
            }

            // mise à jour affichage
            plugin.updateSelectedValues();

            // mise à jour du champ
            plugin.updateField();
        };


        // supprime la valeur value de la selection
        plugin.removeValue = function (value) {
            var pos = $.inArray(value, plugin.selectedValues);

            // pas selectionnée
            if (pos == -1) {
                return;
            }

            // retire la valeur de la selection
            plugin.selectedValues.splice(pos, 1);

            // mise à jour affichage
            plugin.updateSelectedValues();

            // mise à jour du champ
            plugin.updateField();
        };


        // mise à jour graphique de la selection
        plugin.updateSelectedValues = function () {
            // texte à afficher dans le label
            var labelText = 'Selectionnez';

            var items = plugin.items.find('.ui-categoryTree-item');
            for (var i = 0; i < items.length; i++) {
                var item = items.eq(i);
                var value = item.attr('data-value')

                if ($.inArray(value, plugin.selectedValues) != -1) {
                    // cette valeur est sélectionnée
                    item.addClass('selected');
                    labelText = item.text();
                }
                else {
                    // cette valeur n'est pas selectionnée
                    item.removeClass('selected');
                }

            }

            // nombre de valeurs selectionnées
            var c = plugin.selectedValues.length;

            // selection multiple possible
            if (plugin.allowMultiple && c > 0) {
                if (c == 1) {
                    labelText = '1 catégorie sélectionnée';
                }
                else {
                    labelText = c + ' catégories sélectionnées';
                }
            }
            plugin.label.text(labelText);
        };


        // mettre à jour le vrai champ
        plugin.updateField = function () {
            $element.val(plugin.selectedValues);
        };


        // la valeur value fait-elle partie des valeurs sélectionnées
        plugin.hasValue = function (value) {
            if ($.inArray(value, plugin.selectedValues) != -1) {
                return true;
            }
            else {
                return false;
            }
        };


        // init le plugin
        plugin.init();
    };


    $.fn.categoryTree = function (options) {
        if (typeof options === 'object' || !options) {
            return this.each(function () {
                if ($(this).data('categoryTree') == undefined) {
                    var plugin = new $.categoryTree(this, options);
                    $(this).data('categoryTree', plugin);
                }
            });
        }
        else {
            return this.each(function () {
                var plugin = $(this).data('categoryTree');
                plugin[options].call();
            });
        }
    }
})(jQuery);


/*************************************************************************
 *                        MODAL
 *************************************************************************/
var $modal = $('<div id="modal" class="modal modal-alert fade" />');

var modal =
    {
        init: function () {
            "use strict";

            $('body').append($modal);

            $modal.on('submit', 'form', function () {
                var $this = $(this);
                var url = $this.attr('action');
                var datas = $this.serializeArray();

                doc.ajax(url, 'html', datas, function (data) {
                    //si on récup du script, on l'append direct pour faire genre ca ferme joliement la popup
                    if (data.substr(0, 8) !== '<script>') {
                        $modal.empty();
                    }

                    $modal.append($(data));
                });

                return false;
            });

            $modal.on('click', 'a[target="_parent"]', function () {
                modal.refresh($(this).attr('href'));
            });

            $('body').on('click', 'a[rel="modal"]', function () {
                var url = $(this).attr('href');

                $.get(url, function (data) {
                    $modal.html(data).modal('show');
                });

                return false;
            });

        },

        close: function () {
            "use strict";

            $modal.modal('hide');
        },

        open: function (uri) {
            "use strict";

            $.get(site_url + uri, function (data) {
                $modal.html(data).modal('show');
            });
        },

        refresh: function (location_url) {
            "use strict";

            $modal.one('hidden', function () {
                if (location_url) {
                    document.location.href = location_url;
                }
                else {
                    location.reload();
                }
            });

            $modal.modal('hide');
        },

        fill: function (data) {
            "use strict";

            $modal.html(data).modal('show');
        },

        show: function () {
            $modal.modal('show');
        },

        // forge une modal, les 3 params sont "obligatoire" pour l'instant, recoder si besoin est
        forge: function (title, content, footer) {
            var html = '<div class="modal-dialog modal-dialog-centered">';
            html += '<div class="modal-content">';
            html += '<div class="modal-header"><h3 class="modal-title">' + title + '</h3><button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-hidden="true"></button></div>';
            html += '<div class="modal-body"><p>' + content + '</p></div>';
            html += '<div class="modal-footer">' + footer + '</div>';
            html += '</div>';
            html += '</div>';

            $modal.html(html);
            return this;
        }
    };

/*************************************************************************
 * gestion des fichiers espace de stockage (selection/insertion)
 *************************************************************************/

window.stoManager =
    {
        // fonction callback invoquée par la popup de sélection d'image
        onSelectImage: null,

        // valeurs à initialiser pour le formulaire
        form_options: {},

        // sélection d'une image
        selectImage: function (callback, options, context, lineNumber = null, cellNumber = null, lang = null) {
            // en mode sélect, aucun param
            this.form_options = null;

            // enregistrer ce callback
            this.onSelectImage = callback;

            if (options) {
                // url de l'espace de stockage
                var url = site_url + 'site/stoimages/selectoptions';
            }
            else {
                // url de l'espace de stockage
                var url = site_url + 'site/stoimages/select';
            }

            // anti cache
            var ac = new Date().getTime();

            let finalUrl = url + '?ac=' + ac;

            if (context == 'productpics') {
                finalUrl += '&context=productpics';
            }

            if (lineNumber != null) {
                finalUrl += '&lineNumber=' + lineNumber;
            }

            if (cellNumber != null) {
                finalUrl += '&cellNumber=' + cellNumber;
            }

            if (lang != null) {
                finalUrl += '&lang=' + lang;
            }

            doc.openfancyframe(finalUrl);
        },

        // sélection d'une image
        selectPicture: function (callback, options) {
            // en mode sélect, aucun param
            this.form_options = null;

            // enregistrer ce callback
            this.onSelectImage = callback;

            if (options) {
                // url de l'espace de stockage
                var url = site_url + 'cms/album/handle/selectoptions';
            }
            else {
                // url de l'espace de stockage
                var url = site_url + 'cms/album/handle/select';
            }

            // anti cache
            var ac = new Date().getTime();

            // load url
            doc.openfancyframe(url + '?ac=' + ac);
        },

        updateImage: function (callback, image_id, form_options, lineNumber = null, cellNumber = null, lang = null) {
            // enregistrer ce callback
            this.onSelectImage = callback;

            // initialiser le formulaire avec ces valeurs
            this.form_options = form_options;

            // url de l'espace de stockage
            var url = site_url + 'site/stoimages/insertoptions/' + image_id;

            // anti cache
            var ac = new Date().getTime();

            let finalUrl = url + '?ac=' + ac;

            if (lineNumber != null) {
                finalUrl += '&lineNumber=' + lineNumber;
            }

            if (cellNumber != null) {
                finalUrl += '&cellNumber=' + cellNumber;
            }

            if (lang != null) {
                finalUrl += '&lang=' + lang;
            }

            // load url
            doc.openfancyframe(finalUrl);
        },

        // fonction de callback invoquée par la popup de sélection de fichier
        onSelectFile: null,

        // sélection d'un fichier
        selectFile: function (callback, options) {
            // en mode sélect, aucun param
            this.form_options = null;

            // enregistrer ce callback
            this.onSelectFile = callback;

            if (options) {
                // url de l'espace de stockage
                var url = site_url + 'site/stofiles/selectoptions';
            } else {
                // url de l'espace de stockage
                var url = site_url + 'site/stofiles/select/';
            }

            // anti cache
            var ac = new Date().getTime();

            // load url
            doc.openfancyframe(url + '?ac=' + ac);
        },

        updateFile: function (callback, file_id, form_options) {
            // enregistrer ce callback
            this.onSelectFile = callback;

            // initialiser le formulaire avec ces valeurs
            this.form_options = form_options;

            // url de l'espace de stockage
            var url = site_url + 'site/stofiles/insertoptions/' + file_id;

            // anti cache
            var ac = new Date().getTime();

            // load url
            doc.openfancyframe(url + '?ac=' + ac);
        }


    };


window.blocCustom = {
  // fonction callback invoquée par la popup de sélection d'image
  onSelectBloc: null,

  // valeurs à initialiser pour le formulaire
  form_options: {},

  // sélection d'une image
  selectBloc: function (callback, content) {
    this.onSelectBloc = callback;

    var url = site_url + 'site/blocselector';

    // anti cache
    var ac = new Date().getTime();

    if (content !== undefined) {
      doc.openfancyframe(url + '?blocSelected=' + content.customBlocId + '&ac=' + ac);
    } else {
      doc.openfancyframe(url + '?ac=' + ac);
    }
  }
}
